import {ActionContext, Module} from 'vuex';
import RootState from '@/store/rootState';
import remote from '@/remote';
import User from '@/types/User';

export interface UserState {
    loggedIn: boolean;
    user?: User;
}

type UserContext = ActionContext<UserState, RootState>;

const user: Module<UserState, RootState> = {
    namespaced: true,

    state: {
        loggedIn: false,
    },

    actions: {
        async createFakeUser({ commit }: UserContext): Promise<UID> {
            const email = `${Math.random().toString(36).substring(7)}@fake.com`;
            const uid = await remote().createFakeUser(email);
            commit('LOGON', { email, uid, displayName: 'Fake user' } as User);
            return uid;
        },

        async deleteFakeUser({ commit }: UserContext): Promise<void> {
            await remote().deleteFakeUser();
            commit('LOGOUT');
        },

        async login({ commit }: UserContext): Promise<UID | undefined> {
            const myUser = await remote().login();
            if (myUser) {
                commit('LOGON', {
                    email: myUser.email,
                    displayName: myUser.displayName,
                    username: myUser.username,
                    uid: myUser.uid,
                } as User);
                return myUser.uid;
            } else {
                return undefined;
            }
        },

        async logout({ commit }: UserContext): Promise<void> {
            await remote().logout();
            commit('LOGOUT');
        },
    },

    mutations: {
        LOGON(state: UserState, { email, displayName, uid }: User): void {
            state.user = {
                username: email.split('@')[0],
                displayName,
                email,
                uid,
            };
            state.loggedIn = true;
        },

        LOGOUT(state: UserState): void {
            state.user = undefined;
            state.loggedIn = false;
        },
    },
};

export default user;
